import Vue from 'vue';
import Vuex, { ActionContext, Module } from 'vuex';
import UserState from './userState';
import { RootState } from '@/store/rootState';
import { IdTokenClaims } from '@/auth/idTokenClaims';
import { AxiosError, AxiosResponse } from 'axios';
import VueApp, { bus } from '@/main';
Vue.use(Vuex);

export const userStore: Module<UserState, RootState> = {
  namespaced: true,
  state: new UserState(),
  mutations: {
    updateProfile(state: UserState, profile: IdTokenClaims): void {
      state.profile = profile;
    },
    updateEditor(state: UserState, editor: boolean): void {
      Vue.set(state, 'editor', editor);
    },
    updateQueueEditor(state: UserState, queueEditor: boolean): void {
      Vue.set(state, 'queueEditor', queueEditor);
    },
  },
  actions: {
    checkEditorStatus({ commit }: ActionContext<UserState, RootState>, email: string): void {
      if (VueApp) {
        VueApp.$http
          .get<never>('authorizededitor?email=' + email)
          .then((result: AxiosResponse<boolean>) => {
            commit('updateEditor', result.data);
          })
          .catch((error: AxiosError) => {
            bus.$emit('alert', 'Check editor status failed', 'error', 6000, error);
          });
      }
    },
    checkQueueEditorStatus({ commit }: ActionContext<UserState, RootState>, email: string): void {
      if (VueApp) {
        VueApp.$http
          .get<never>('queueeditor?email=' + email)
          .then((result: AxiosResponse<boolean>) => {
            commit('updateQueueEditor', result.data);
          })
          .catch((error: AxiosError) => {
            bus.$emit('alert', 'Check queue editor status failed', 'error', 6000, error);
          });
      }
    },
  },
  getters: {
    profile: (state: UserState): UserState => {
      return state;
    },
    editor: (state: UserState): boolean | undefined => {
      return state.editor;
    },
    queueEditor: (state: UserState): boolean | undefined => {
      return state.queueEditor;
    },
  },
};
